// HomePage.tsx - Enhanced with BrowseContractors component
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import HeroSection from "./HeroSection";
import HowItWorksSection from "./HowItWorksSection";
import TrustAndSafetySection from "./TrustAndSafetySection";
import SocialProofSection from "./SocialProofSection"
import PopularServices from "./PopularServices";
import ValuePropositionSection from "./ValuePropositionSection";
import SmartMatchingSection from "./SmartMatchingSection";
//import ProjectPlanningSection from "./ProjectPlanningSection";
//import ContactSection from "./ContactSection";
//import MobileFeaturesSection from "./MobileFeaturesSection";
//import ResourcesSection from "./ResourcesSection";
import ContractorSignupSection from "./ContractorSignupSection";
import LocationServicesSection from "./LocationServicesSection";
import BrowseContractors from "./BrowseContractors";
import "./HomePage.css";

const HomePage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Enhanced SEO meta tags
    document.title = "BidBro: Find Trusted Local Contractors - Get Competitive Bids Upfront";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Find trusted local contractors on BidBro. Get competitive bids upfront without property visits. Browse contractors by location and service category across Virginia Beach, Chesapeake, Norfolk and beyond.'
      );
    }

    // Add schema markup for homepage
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "BidBro",
      "description": "Find trusted local contractors and get competitive bids upfront",
      "url": "https://bidbro.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://bidbro.com/contractors?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };

    // Add/update schema script
    let schemaScript = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    if (schemaScript) {
      schemaScript.textContent = JSON.stringify(schema);
    } else {
      schemaScript = document.createElement('script') as HTMLScriptElement;
      schemaScript.type = 'application/ld+json';
      schemaScript.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }
  }, []);

  const handleSearch = (query: string) => {
    if (!query.trim()) return;

    const params = new URLSearchParams();
    params.set("q", query);
    navigate(`/contractors?${params.toString()}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <HeroSection />

      <HowItWorksSection />

      <TrustAndSafetySection />

      <SocialProofSection />

      <PopularServices />

      <ValuePropositionSection />

      <SmartMatchingSection />
      {/*
      <ProjectPlanningSection />

      <ContactSection />
   
      <MobileFeaturesSection />

      <ResourcesSection />
      */}
      <ContractorSignupSection />

      {/*<LocationServicesSection />*/}

      <BrowseContractors />

      <Footer />
    </div>
  );
};

export default HomePage;